import { useContext } from 'react';

import * as graphql from '@treams/treams-network';

import AuthorizationContext from '../../../../src/packages/kakapo-ui-application/contexts/AuthorizationContext';

export function useViewer(): graphql.User | undefined {
	const context = useContext(AuthorizationContext)!;

	return context?.authenticatedUser ?? undefined;
}
